import React from "react";
import ShopSettings from "../../components/Shop/ShopSettings";
import DashboardHeader from "../../components/Shop/Layout/DashboardHeader";
import DashboardSideBar from "../../components/Shop/Layout/DashboardSideBar";
import ShopManagementPageHero from "../../components/Shop/Layout/ShopManagementPageHero";
import { Link } from "react-router-dom";

const ShopSettingsPage = () => {
  return (
    <div className="shop-settings-page-container">
      <DashboardHeader />
      <div className="shop-settings-page-content shop-management-layout">
        <div className="shop-settings-page-sidebar shop-management-sidebar-slot">
          <DashboardSideBar active={4} />
        </div>
        <main className="shop-settings-page-main shop-management-main-panel">
          <ShopManagementPageHero
            eyebrow="Shop Settings"
            title="Store Profile"
            copy="Update your public shop details, location, hours, and payment access from one organized workspace."
          />
          <ShopSettings />
          <div className="shop-settings-page-manage-payment">
            <Link to="/payment-method" className="shop-settings-page-manage-payment-btn">
              Manage Payment Method
            </Link>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ShopSettingsPage;

